import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form, Select, Radio } from "antd";
import {
  isReferralOption,
  referralOptions,
  referrals,
  isReferral,
} from "../../stores/ContactViewStore";
import { css } from "@emotion/core";
import { longLabel } from "../../style/form";
import { AnnotatedFormItem } from "./AnnotatedFormItem";

export const ReferralOptionFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <div>
      <Form.Item label="どなたに紹介されましたか？" css={longLabel}>
        <Select
          value={store.referralOption}
          onChange={(value: any) => {
            if (!isReferralOption(value)) return;
            store.referralOption = value;
          }}
        >
          {referralOptions.map((r, i) => (
            <Select.Option key={i} value={r}>
              {r}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {store.referralOption === "プランナー・アドバイザー" ? (
        <div>
          <Form.Item label="選択してください" css={longLabel}>
            <Radio.Group
              onChange={(e) => {
                if (!isReferral(e.target.value)) return;
                store.referral = e.target.value;
              }}
              value={store.referral}
            >
              {referrals.map((r, i) => (
                <Radio value={r} key={i}>
                  {r}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
          <AnnotatedFormItem
            label="担当者等の名前"
            annotation="任意"
            itemCss={longLabel}
          >
            <Input
              value={store.referralStaffName}
              onChange={(e) => {
                store.referralStaffName = e.target.value;
              }}
            />
          </AnnotatedFormItem>
        </div>
      ) : (
        store.referralOption !== "選択してください" &&
        store.referralOption !== "紹介なし" &&
        ((props) => (
          <div>
            {store.referralOption === "紹介コード" ? (
              <Form.Item {...props} />
            ) : (
              <AnnotatedFormItem annotation="任意" {...props} />
            )}
          </div>
        ))({
          label: "紹介コードを入力してください",
          css: longLabel,
          children: (
            <Input
              value={store.referralStaffName}
              onChange={(e) => {
                store.referralStaffName = e.target.value;
              }}
            />
          ),
        })
      )}
    </div>
  );
});
